__webpack_require__.p = "/afaq-frontend/";